const CLASSES = {
  SHOW: "show",
  CARD_EXPANDED: "card-expanded"
};

const SELECTORS = {
  LINK_HEADER: ".card-header a"
};

class Accordion {

  toogleBodyDisplay(elementIndex) {
    let element = this.accordionsCardsLinks[ elementIndex ];
    let isExpanded = element.getAttribute("aria-expanded");
    let dataTargetAttr = element.getAttribute("data-target");

    if (isExpanded === "true") {
      element.setAttribute("aria-expanded", "false");
      if (!this.findHashTag(dataTargetAttr)) {
        document.getElementById(dataTargetAttr).classList.remove(CLASSES.SHOW);
      };
      element.classList.remove(CLASSES.SHOW);
      element.parentElement.parentElement.classList.remove(CLASSES.CARD_EXPANDED);
    } else {

      // si l'accordéon n'est pas en mode multi, fermer toutes les lignes
      if (!element.parentElement.parentElement.classList.contains("multi")) {
        for (let i = 0; i < this.accordionsCardsLinks.length; i++) {
          let elt = this.accordionsCardsLinks[ i ];
          elt.classList.remove(CLASSES.SHOW);
          elt.parentElement.parentElement.classList.remove(CLASSES.CARD_EXPANDED);
        }
      }

      // ouvrir la ligne sélectionnée
      element.setAttribute("aria-expanded", "true");
      if (!this.findHashTag(dataTargetAttr)) {
        document.getElementById(element.getAttribute("data-target")).classList.add(CLASSES.SHOW);
      };
      element.classList.add(CLASSES.SHOW);
      element.parentElement.parentElement.classList.add(CLASSES.CARD_EXPANDED);
    }
  }

  /**
   * Verifie si un string a un hashtag préfixé au debut
   * @param {string} str
   * @returns {boolean}
   */
  findHashTag(str) {
    return typeof str === "string" && str.indexOf("#") === 0;
  }

  init(container) {
    this.container = container;
    this.accordionsCardsLinks = container.querySelectorAll(SELECTORS.LINK_HEADER);

    this._onClick = (index) => {
      this.toogleBodyDisplay(index);
    };

    this._onClicks = [];
    for (let i = 0; i < this.accordionsCardsLinks.length; i++) {
      let linkToSet = this.accordionsCardsLinks[ i ];

      // On met un listener pour pouvoir ouvrir ou fermer un bloc de l'accordéon
      this._onClicks[ i ] = this._onClick.bind(this, i);
      linkToSet.addEventListener("click", this._onClicks[ i ]);

      if (linkToSet.classList.contains(CLASSES.SHOW)) {
        linkToSet.parentElement.parentElement.classList.add(CLASSES.CARD_EXPANDED);
      }
    }
  }

  constructor(container) {
    if (container) {
      if (typeof container.dataset.ref === "undefined") {
        this.ref = Math.random();
        Accordion.refs[ this.ref ] = this;
        container.dataset.ref = this.ref;
        this.init(container);
      } else {

        // If this element has already been instantiated, use the existing reference.
        return Accordion.refs[ container.dataset.ref ];
      }
    }
  }

  /**
   * Décharge le composant
   */
   dispose () {

    // suppression de tous les event listeners qui ont été créés
    this.accordionsCardsLinks = container.querySelectorAll(SELECTORS.LINK_HEADER);
    for (let i = 0; i < this.accordionsCardsLinks.length; i++) {
      let linkToSet = this.accordionsCardsLinks[ i ];
      linkToSet.removeEventListener("click", this._onClicks[ i ]);
    }
  }
}

Accordion.refs = {};

document.addEventListener("DOMContentLoaded", () => {
  let accordions = document.querySelectorAll(".accordion");
  [].forEach.call(accordions, (accordion) => {
    new Accordion(accordion);
  });
});

// rattachement au contexte window pour pouvoir l'utiliser en dehors du JS
window.Accordion = Accordion;

export default Accordion;
